import axios from "axios";
import {getAppLang, getProperty, getUserToken, isDefined} from "../../../../utils";
import {
    WEB_FAQ_LIST,
    WEB_FAQ_DETAIL,
    CREATE_WEB_FAQ,
    UPDATE_WEB_FAQ,
    DELETE_WEB_FAQ,
    SORT_WEB_FAQ,
    OPEN_AI,
} from "../../../../constants/api.constants";
import {faqConstants} from "../../../../constants/Web/faq.constants";

const requestHeaders = () => ({
    'Content-Type': 'application/json',
    'authToken': getUserToken(),
    'language': getAppLang(),
});

// Tum SSS gruplarini (order_number sirali) getirir. Her grup sadece GIRILMIS dilleri tasir.
export function getFaqList(params) {

    const requestOptions = {
        headers: requestHeaders(),
        body: {
            params: {
                property_id: getProperty(),
                property_web_id: params?.property_web_id,
            }
        }
    };

    return dispatch => {
        dispatch({
            type: 'FAQ_LIST',
            payload: axios.post(WEB_FAQ_LIST, requestOptions.body, {headers: requestOptions.headers})
                .then(response => response.data.data)
        })
    }
}

// Tek grubun detayi; TUM uygulama dilleri slotlu doner (girilmeyen dilde question/answer null).
export function getFaqDetail(params) {

    const requestOptions = {
        headers: requestHeaders(),
        body: {
            params: {
                property_id: getProperty(),
                property_web_id: params?.property_web_id,
            }
        }
    };

    return dispatch => {
        dispatch({
            type: 'FAQ_DETAIL',
            payload: axios.post(`${WEB_FAQ_DETAIL}/${params?.faq_group_id}`, requestOptions.body, {headers: requestOptions.headers})
                .then(response => response.data.data)
        })
    }
}

export function createFaq(params) {

    const requestOptions = {
        headers: requestHeaders(),
        body: {
            params: {
                property_id: getProperty(),
                property_web_id: params?.property_web_id,
                action: params?.action ? params.action : "publish",
                faq: params?.faq,
            }
        }
    };

    return dispatch => {
        dispatch({
            type: 'CREATE_FAQ',
            payload: axios.post(CREATE_WEB_FAQ, requestOptions.body, {headers: requestOptions.headers})
                .then(response => response.data)
        })
    }
}

// Grubu yeniden yazar: gonderilmeyen dil silinir, order_number korunur.
export function updateFaq(params) {

    const requestOptions = {
        headers: requestHeaders(),
        body: {
            params: {
                property_id: getProperty(),
                property_web_id: params?.property_web_id,
                action: params?.action ? params.action : "publish",
                faq: params?.faq,
            }
        }
    };

    return dispatch => {
        dispatch({
            type: 'UPDATE_FAQ',
            payload: axios.post(`${UPDATE_WEB_FAQ}/${params?.faq_group_id}`, requestOptions.body, {headers: requestOptions.headers})
                .then(response => response.data)
        })
    }
}

export function deleteFaq(params) {

    const requestOptions = {
        headers: requestHeaders(),
        body: {
            params: {
                property_id: getProperty(),
                property_web_id: params?.property_web_id,
            }
        }
    };

    return dispatch => {
        dispatch({
            type: 'DELETE_FAQ',
            payload: axios.post(`${DELETE_WEB_FAQ}/${params?.faq_group_id}`, requestOptions.body, {headers: requestOptions.headers})
                .then(response => response.data)
        })
    }
}

// faq_order: [{ faq_group_id, order_number }]
export function sortFaq(params) {

    const requestOptions = {
        headers: requestHeaders(),
        body: {
            params: {
                property_id: getProperty(),
                property_web_id: params?.property_web_id,
                faq_order: params?.faq_order,
            }
        }
    };

    return dispatch => {
        dispatch({
            type: 'SORT_FAQ',
            payload: axios.post(SORT_WEB_FAQ, requestOptions.body, {headers: requestOptions.headers})
                .then(response => response.data)
        })
    }
}

// Tek dilde yazilan soru/cevabi AI ile tum uygulama dillerine cevirir.
// Donen veri create/update'in faq[] semasi ile ayni: [{ language_code, question, answer }]
export function translateFaq(params) {

    const targetLanguages = isDefined(params?.languages) ? params.languages : [];
    const languageCodes = targetLanguages.map(lang => lang?.code).filter(code => isDefined(code));

    const requestOptions = {
        headers: requestHeaders(),
        body: {
            params: {
                property_id: getProperty(),
                query: {
                    model: "gpt-4.1-mini",
                    temperature: 0.2,
                    response_format: {type: "json_object"},
                    messages: [
                        {
                            role: "system",
                            content: "You are a professional translator for hotel websites. Translate the FAQ question and answer faithfully and naturally into every requested language. Return ONLY a JSON object, no prose."
                        },
                        {
                            role: "user",
                            content: `Source language: ${params?.source_language_code}\nQuestion: ${params?.question}\nAnswer: ${params?.answer ? params.answer : ""}\n\n`
                                + `Translate into these languages (language_code): ${languageCodes.join(", ")}.\n`
                                + `Return a JSON object EXACTLY in this shape: {"faq":[{"language_code":"..","question":"..","answer":".."}]} `
                                + `with one item per language_code above (include the source language too). `
                                + `Keep numbers, times and formatting unchanged; translations must sound natural for a hotel website.`
                        }
                    ]
                },
            }
        }
    };

    return dispatch => {
        dispatch({
            type: 'TRANSLATE_FAQ',
            payload: axios.post(OPEN_AI, requestOptions.body, {headers: requestOptions.headers})
                .then(response => response.data.data)
        })
    }
}

export function clearFaqDetail() {
    return dispatch => {
        dispatch({
            type: faqConstants.FAQ_DETAIL_CLEAR,
        })
    }
}

export function createFaqClearState() {
    return dispatch => {
        dispatch({
            type: faqConstants.CREATE_FAQ_CLEAR,
        })
    }
}

export function updateFaqClearState() {
    return dispatch => {
        dispatch({
            type: faqConstants.UPDATE_FAQ_CLEAR,
        })
    }
}

export function deleteFaqClearState() {
    return dispatch => {
        dispatch({
            type: faqConstants.DELETE_FAQ_CLEAR,
        })
    }
}

export function sortFaqClearState() {
    return dispatch => {
        dispatch({
            type: faqConstants.SORT_FAQ_CLEAR,
        })
    }
}

export function translateFaqClearState() {
    return dispatch => {
        dispatch({
            type: faqConstants.TRANSLATE_FAQ_CLEAR,
        })
    }
}
